import { render, staticRenderFns } from "./PrivateMessages.vue?vue&type=template&id=4f61b07d&scoped=true"
import script from "./PrivateMessages.vue?vue&type=script&lang=js"
export * from "./PrivateMessages.vue?vue&type=script&lang=js"
import style0 from "./PrivateMessages.vue?vue&type=style&index=0&id=4f61b07d&prod&scoped=true&lang=css"
import style1 from "./PrivateMessages.vue?vue&type=style&index=1&id=4f61b07d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61b07d",
  null
  
)

export default component.exports